import { loadStripe } from '@stripe/stripe-js';
import { apiFetch } from './api';
import { auth } from './firebase';

let stripePromise;
export function getStripe() {
  if (!stripePromise) {
    stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
}

export async function previewUpgrade(tier, interval) {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error('Not authenticated');
  const res = await apiFetch(`/api/billing/upgrade/preview?tier=${tier}&interval=${interval}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function executeUpgrade(tier, interval) {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error('Not authenticated');
  const res = await apiFetch('/api/billing/upgrade', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ tier, interval }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function redirectToCheckout(plan) {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error('Not authenticated');
  const res = await apiFetch('/api/billing/checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({
      tier: 'pro',
      interval: plan,
      success_url: `${window.location.origin}/platform?upgraded=1`,
      cancel_url: `${window.location.origin}/billing`,
    }),
  });
  if (!res.ok) throw new Error(await res.text());
  const { checkout_url } = await res.json();
  window.location.href = checkout_url;
}
